'use client';

import FadeIn from '../ui/FadeIn';
import { ChevronDown } from 'lucide-react';
import { useTranslations } from '@/lib/i18n/TranslationProvider';

export default function FAQ() {
    const { t } = useTranslations();
    const faqs = t.faq.items;


    // FAQ Schema for Google Rich Snippets
    const faqSchema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": faqs.map(faq => ({
            "@type": "Question",
            "name": faq.q,
            "acceptedAnswer": {
                "@type": "Answer",
                "text": faq.a
            }
        }))
    };

    return (
        <section id="faq" className="section-padding bg-[var(--color-md-surface)] relative overflow-hidden">
            {/* FAQ Schema for Rich Snippets */}
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
            />

            <div className="container mx-auto px-6 max-w-3xl relative z-10">
                <FadeIn className="text-center mb-16">
                    <h2 className="text-4xl md:text-6xl font-black text-[var(--color-md-on-surface)] tracking-tight mb-6">
                        {t.faq.heading}
                    </h2>
                    <p className="text-lg text-[var(--color-md-on-surface-variant)] font-medium">
                        {t.faq.subtitle}
                    </p>
                </FadeIn>

                <div className="space-y-4">
                    {faqs.map((faq, i) => (
                        <FadeIn key={i} delay={i * 0.05} yOffset={20}>
                            <details className="group bg-[var(--color-md-surface-variant)] border border-[var(--color-md-outline)] rounded-[32px] overflow-hidden [&_summary::-webkit-details-marker]:hidden">
                                <summary className="flex cursor-pointer items-center justify-between p-7 text-lg font-bold text-[var(--color-md-on-surface)] outline-none transition-colors hover:text-[var(--color-md-primary)]">
                                    {faq.q}
                                    <span className="relative ml-4 h-5 w-5 shrink-0">
                                        <ChevronDown className="absolute inset-0 h-5 w-5 transition-all duration-300 group-open:rotate-180" />
                                    </span>
                                </summary>
                                <div className="px-7 pb-7 text-base leading-relaxed text-[var(--color-md-on-surface-variant)]">
                                    <p>{faq.a}</p>
                                </div>
                            </details>
                        </FadeIn>
                    ))}
                </div>

                <FadeIn delay={0.5} className="mt-16 text-center">
                    <div className="inline-flex items-center gap-4 p-4 rounded-3xl bg-[var(--color-md-surface-variant)] border border-[var(--color-md-outline)]">
                        <span className="text-sm font-bold text-[var(--color-md-on-surface)]">{t.faq.stillHaveQuestions}</span>
                        <a href="mailto:support@houseof2.studio" className="px-6 py-2 bg-[var(--color-md-primary)] text-white text-sm font-black rounded-full hover:scale-105 transition-all shadow-lg">
                            {t.faq.chatWithUs}
                        </a>
                    </div>
                </FadeIn>
            </div>
        </section>
    );
}
